import styled from "@emotion/styled";
import LoadingAndErrorWrapper from "metabase/components/LoadingAndErrorWrapper";

export const LoadingAndErrorRoot = styled(LoadingAndErrorWrapper)`
  display: flex;
  flex-direction: column;
  min-height: 565px;
`;
